import React from "react";
import { airlineName } from "../../js/lib/filters";
import { scrollTo } from "../../js/lib/trip";
import { Flight, ItineraryWidgetProps } from "../../js/headersegment/interfaces";

const ItineraryWidget: React.FC<ItineraryWidgetProps> = ({ trip }) => {

    return (<>
      <div className="widget">
        <div className="header">ITINERARY</div>
        <div className="data itinerary-legs">
          {trip.legs.map((leg, legIndex) => (
            <div key={legIndex} className="leg-separator">
              <div className="leg-route">
                <span>
                  <a href="#" onClick={(event: any) => scrollTo(`leg-${legIndex + 1}`, event)}>
                    Leg {legIndex + 1} - {leg.departureAirportCityState} to{' '}
                    {leg.arrivalAirportCityState}
                  </a>
                </span>
              </div>
              <div className="leg-details">
                {leg.flights.map((flight: Flight, flightIndex: number) => (
                  <div key={flightIndex}>
                    {flight?.hops?.map((hop, hopIndex) => (
                      <div key={hopIndex}>
                        <span>
                          {airlineName(hop.airline)} {hop.number}
                        </span>
                        {hop.connection && (
                          <div>
                            <span className="highlight">CONNECTION</span>
                            &nbsp;&nbsp;
                            <span>{hop.connection.inFull}</span>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>);
}

export default ItineraryWidget;